const STEPS = [
  'Our team will check your Medicare Part D coverage and the other Bridge requirements. If you qualify and the medication is approved through Bridge, the program copay is $50 per month for an eligible medication.',
  'Your prescriber will write the prescription and send it to your chosen pharmacy.',
  'Contact the pharmacy promptly and ask them to process it through Medicare Bridge. If you receive a prescription that has not been sent electronically, get it to the pharmacy as soon as possible. The pharmacy starts the Bridge eligibility check and requests any required prior authorization.',
  'Our care team will submit the clinical information for the Bridge prior authorization when it is requested.',
  'We will let you know when there is a decision. Once it is approved and the pharmacy confirms the medication is ready, you can pick it up. Timing can vary.',
];

/** Prescriber script for the visit review and the prescription task. */
export function MedicareBridgePatientGuide() {
  return (
    <section
      className="flex flex-col gap-2"
      data-testid="medicare-bridge-patient-guide"
    >
      <h3 className="text-sm font-semibold text-foreground">
        What to tell the patient
      </h3>
      <ol className="list-decimal pl-5 text-sm text-foreground">
        {STEPS.map((step) => (
          <li key={step}>{step}</li>
        ))}
      </ol>
      <p className="text-sm text-muted-foreground">
        Part D coverage alone does not establish Bridge eligibility, and an
        eligible review is not final approval. The pharmacy uses the Medicare
        Bridge prior authorization route.
      </p>
    </section>
  );
}
